import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
// Preview round pairings (dry run, nothing persisted)
export function usePreviewRound(tournamentId, roundNumber) {
    return useQuery({
        queryKey: ['rounds', tournamentId, roundNumber, 'preview'],
        queryFn: () => api.request(`/api/tournaments/${tournamentId}/rounds/preview`, {
            method: 'POST',
            body: JSON.stringify({ round_number: roundNumber }),
        }),
        enabled: tournamentId > 0 && roundNumber > 0,
    });
}
// Lock (persist) a round with given pairings
export function useLockRound() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ tournamentId, roundNumber, body, }) => api.request(`/api/tournaments/${tournamentId}/rounds/${roundNumber}/lock`, {
            method: 'POST',
            body: JSON.stringify(body),
        }),
        onSuccess: (_data, { tournamentId, roundNumber }) => {
            void qc.invalidateQueries({ queryKey: ['rounds', tournamentId] });
            void qc.invalidateQueries({ queryKey: ['rounds', tournamentId, roundNumber] });
            void qc.invalidateQueries({ queryKey: ['tournaments', tournamentId] });
        },
    });
}
// Fetch a locked round with its matches
export function useGetRound(tournamentId, roundNumber) {
    return useQuery({
        queryKey: ['rounds', tournamentId, roundNumber],
        queryFn: () => api.request(`/api/tournaments/${tournamentId}/rounds/${roundNumber}`),
        enabled: tournamentId > 0 && roundNumber > 0,
    });
}
